import {
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Row,
  Col,
  Divider,
  Button,
  Image,
} from "antd";
import React, { useEffect, useState } from "react";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import PhoneInput from "react-phone-input-2";
import { PERMISSION_MODULE_KEYS } from "../../constants/conts";
import SingleImageUpload from "../../components/SingleImageUpload";
import notfound from "../../assets/images/not_found.png";

const { Option } = Select;

// const MODULES = [
//   "users",
//   "posts",
//   "groups",
//   "tags",
//   "rewards",
//   "advertisements",
// ];

const ACTIONS = ["create", "read", "update", "delete"];
const POST_ACTIONS = ["read", "delete"];

const SubAdminForm = ({
  sectionName,
  path,
  show,
  hide,
  data,
  refresh,
  isUpdate,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const [mobileNumber, setMobileNumber] = useState({
    mobile_number: "",
    country_code: "",
  });

  // 🔹 Build default permissions structure
  const buildDefaultPermissions = () => {
    const permissions = {};
    PERMISSION_MODULE_KEYS.forEach((module) => {
      permissions[module] = {
        enabled: false,
        permissions: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      };
    });
    return permissions;
  };

  const handleChange = (value, data) => {
    var country_code = data?.dialCode;
    setMobileNumber({
      country_code: country_code,
      mobile_number: value?.slice(data?.dialCode?.length),
    });
  };

  const onFinish = (values) => {
    setLoading(true);

    const payload = {
      name: values.name,
      email: values.email,
      mobile_number: mobileNumber?.mobile_number,
      country_code: mobileNumber?.country_code,
      password: values.password,
      role: values.role,
      status: values.status,
      permissions: values.permissions,
      profilePic: values.image,
    };

    if (isUpdate) {
      request({
        url: `${apiPath.updateSubAdmin}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (res) => {
          setLoading(false);
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
          form.resetFields();
        },
        onError: (err) => {
          setLoading(false);
          ShowToast(err?.response?.data?.message, Severty.ERROR);
        },
      });
    } else {
      request({
        url: apiPath.addSubAdmin,
        method: "POST",
        data: payload,
        onSuccess: (res) => {
          setLoading(false);
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
          form.resetFields();
        },
        onError: (err) => {
          setLoading(false);
          ShowToast(err?.response?.data?.message, Severty.ERROR);
        },
      });
    }
  };

  //------------- USE EFFECT ------------
  useEffect(() => {
    if (!data) return;
    if (isUpdate) {
      form.setFieldsValue({
        ...data,
        mobile: `${data?.countryCode || ""}${data?.phoneNumber || ""}`,
      });
    }
    setImage(data?.profilePic);
  }, [data]);

  return (
    <Modal
      open={show}
      width={700}
      title={isUpdate ? "Update Sub Admin" : "Add Sub Admin"}
      onCancel={hide}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          role: "MODERATOR",
          status: "Active",
          permissions: buildDefaultPermissions(),
        }}
        onFinish={onFinish}
      >
        {/* BASIC DETAILS */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, type: "email", message: "Enter valid email" },
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>

          <Col span={12} className="flagMobileNumber">
            <Form.Item
              className="mb-1"
              label="Mobile Number"
              name="mobile"
              validateTrigger={["onBlur", "onSubmit"]}
              rules={[
                {
                  required: true,
                  message: "Please enter a mobile number",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    let digitsOnly = value.replace(/\D/g, "");
                    digitsOnly = digitsOnly.slice(
                      String(mobileNumber.country_code).length,
                    );
                    if (digitsOnly.length < 8 || digitsOnly.length > 12) {
                      return Promise.reject(
                        new Error(
                          "Mobile number must be between 8 and 12 digits",
                        ),
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                country="in"
                value={form.getFieldValue("mobile")}
                inputProps={{
                  name: "mobile",
                  required: true,
                  placeholder: "Enter Mobile Number",
                }}
                onChange={(value, country) => {
                  // ✅ Keep AntD Form in sync
                  form.setFieldsValue({ mobile: value });

                  // ✅ Store split values for backend
                  setMobileNumber({
                    country_code: country.dialCode,
                    mobile_number: value.slice(country.dialCode.length),
                  });
                }}
              />
            </Form.Item>
          </Col>

          {!isUpdate && (
            <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please enter password" },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters",
                  },
                ]}
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>
            </Col>
          )}

          <Col span={24} md={12}>
            <Form.Item
              className=""
              label="Upload Profile Image"
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    // return Promise.reject(new Error(lang("Image is required")));
                    return Promise.resolve();
                  },
                },
              ]}
              name="image"
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"profilePic"}
                btnName={"Upload Image"}
                onChange={(data) => setImage(data)}
                isDimension={false}
              />
            </Form.Item>
            <p className="img-size-details">
              You can select only image, pdf format files upto 5 MB file size
            </p>
            {
              <div className="mt-2 add-img-product">
                {" "}
                {image ? (
                  <Image width={120} src={image ?? notfound}></Image>
                ) : (
                  ""
                )}{" "}
              </div>
            }
          </Col>

          <Col span={6}>
            <Form.Item label="Role" name="role">
              <Select>
                <Option value="MODERATOR">Moderator</Option>
                <Option value="CONTENT_MANAGER">Content Manager</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="Status" name="status">
              <Select>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Divider orientation="left">Permissions</Divider>

        {/* PERMISSIONS */}
        {PERMISSION_MODULE_KEYS.map((module) => {
          const enabledPath = ["permissions", module, "enabled"];
          return (
            <div
              key={module}
              style={{
                padding: "12px 16px",
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                marginBottom: 16,
              }}
            >
              <Row align="middle" gutter={[16, 8]}>
                {/* MODULE ENABLE */}
                <Col span={6}>
                  <Form.Item
                    name={enabledPath}
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox>
                      <b
                        style={{
                          textTransform: "capitalize",
                          fontSize: "12px",
                        }}
                      >
                        {module}
                      </b>
                    </Checkbox>
                  </Form.Item>
                </Col>

                {/* PERMISSIONS */}
                <Col span={18}>
                  <Form.Item shouldUpdate noStyle>
                    {({ getFieldValue, setFieldsValue }) => {
                      const isEnabled = getFieldValue(enabledPath);

                      return (
                        <Row gutter={[12, 8]}>
                          {(module === "POST_MANAGER"
                            ? POST_ACTIONS
                            : ACTIONS
                          ).map((action) => (
                            <Col span={6} key={action}>
                              <Form.Item
                                name={[
                                  "permissions",
                                  module,
                                  "permissions",
                                  action,
                                ]}
                                valuePropName="checked"
                                style={{ marginBottom: 0 }}
                              >
                                <Checkbox
                                  disabled={!isEnabled}
                                  onChange={(e) => {
                                    // 🔥 auto-enable module if any permission checked
                                    if (e.target.checked && !isEnabled) {
                                      setFieldsValue({
                                        permissions: {
                                          [module]: { enabled: true },
                                        },
                                      });
                                    }
                                  }}
                                >
                                  {action.charAt(0).toUpperCase() +
                                    action.slice(1)}
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          ))}
                        </Row>
                      );
                    }}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          );
        })}

        {/* FOOTER */}
        <Row justify="end">
          <Button
            onClick={hide}
            icon={<CloseOutlined />}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<CheckOutlined />}
          >
            Save
          </Button>
        </Row>
      </Form>
    </Modal>
  );
};

export default SubAdminForm;
